import { render } from "./FiltersEdit.vue?vue&type=template&id=5c4a13e1"
import script from "./FiltersEdit.vue?vue&type=script&lang=js"
export * from "./FiltersEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/bambl/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__